<section class="">
  <div class="row pt-3 pb-2">
    <div class="col-md-4">
      <!-- <h4 class="custom-content">{{ header }}</h4> -->
    </div>
    <div class="col-md-8">
      @if (requirement.actions.includes('Asignar')) {
        <button type="button" class="btn btn-icon btn-pure secondary mr-1" (click)="assign()"><i class="inp-btn-md inp-icon-asignar"></i>Asignar</button>
      }
      @if (requirement.actions.includes('Tomar')) {
        <button type="button" class="btn btn-icon btn-pure secondary mr-1" (click)="take()"><i class="inp-btn-md inp-icon-tomar"></i>Tomar</button>
      }
      @if (requirement.actions.includes('Devolver')) {
        <button type="button" class="btn btn-icon btn-pure secondary mr-1" (click)="return()"><i class="inp-btn-md inp-icon-devolver"></i>Devolver</button>
      }
    </div>
  </div>
</section>
